module.exports = __webpack_public_path__ + "static/img/y60.3d625c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y60.jpg
// module id = tMtV
// module chunks = 1